import styled from 'styled-components';
import theme from 'v3/theme';

export const Wrapper = styled.div`
  margin-bottom: 16px;
`;

export const Subquestions = styled.div`
  position: relative;
  margin-top: 12px;
  margin-left: 8px;
  padding-left: 20px;
  border-left: 2px solid ${theme.colors.grayish_blue};
`;

export const SubquestionItem = styled.div`
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 12px;
    left: -20px;
    width: 14px;
    height: 2px;
    background: ${theme.colors.grayish_blue};
  }
`;

export const SubquestionLabel = styled.span`
  display: block;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${theme.colors.checklist_gray};
  margin-bottom: 2px;
`;
